var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: (_vm.bgcolor ? "" : "primary ") + "text-xs-center",
      style: {
        height: 32 + "px",
        width: 32 + "px",
        "border-radius": "50%",
        padding: 5 + "px",
        "padding-top": _vm.src ? 5 + "px" : "18px",
        "background-color": _vm.bgcolor || ""
      }
    },
    [
      _vm.src
        ? _c("v-img", {
            style: { height: 22 + "px", width: 22 + "px" },
            attrs: { src: _vm.src }
          })
        : _vm.initials
        ? _c("span", {
            staticClass: "white--text headline",
            domProps: { textContent: _vm._s(_vm.initials) }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f3670c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f3670c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/components/bm-ib-avatar-widget/template.html
// module id = null
// module chunks = 